import { render } from "./StatusPengajuanTemplate.vue?vue&type=template&id=1676c1e1"
import script from "./StatusPengajuanTemplate.vue?vue&type=script&lang=js"
export * from "./StatusPengajuanTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__